import { render, staticRenderFns } from "./ubie.vue?vue&type=template&id=2dd84cc8&"
import script from "./ubie.vue?vue&type=script&lang=js&"
export * from "./ubie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports